import {h} from 'preact';
import {
	addScreenModeListener,
	removeScreenModeListener,
	ScreenMode,
} from '~/app/utils/Screen';
import {debouncedFetchList} from './asyncActions/fetchList';
import List from './List';
import {setListMode} from './Store/creators/listData';
import {dispatch, getState, SubscribedComponent} from './Store/index';
import State from './Store/State';
import Table from './Table';
import listStateToQueryString from './utils/listStateToQueryString';
import updateAddress from './utils/updateAddress';

/**
 * Component Properties.
 */
interface RootListProps
{
	[key: string]: void;
}

/**
 * Component State.
 */
interface RootListState
{
	/** Режим вывода списка вместо таблицы */
	listMode: boolean;
}

/**
 * Корень вида списком.
 */
class RootList extends SubscribedComponent<State, RootListProps, RootListState>
{
	/**
	 * Корень вида списком.
	 */
	public constructor( props: RootListProps )
	{
		super( props );
	}
	
	/**
	 * Rendered component mounted to the DOM.
	 */
	public componentDidMount(): void
	{
		addScreenModeListener( this.onScreenModeChange );
		
		// Актуализируем адресную строку и список.
		const query = listStateToQueryString( getState().filter );
		updateAddress( query );
		debouncedFetchList( query );
	}
	
	/**
	 * Before component will be unmounted and destroyed.
	 */
	public componentWillUnmount(): void
	{
		removeScreenModeListener( this.onScreenModeChange );
	}
	
	/**
	 * Render component.
	 */
	public render(
		_props: RootListProps,
		{listMode}: RootListState,
	): JSX.Element
	{
		return (
			listMode
			? <List />
			: <Table />
		);
	}
	
	/**
	 * Handle Store changes.
	 */
	protected storeStateChanged(
		{listData: {listMode}}: State,
	): void
	{
		if ( listMode === this.state.listMode )
		{
			return;
		}
		
		this.setState( {listMode} );
	}
	
	/**
	 * При изменении режима экрана.
	 */
	private onScreenModeChange = ( mode: ScreenMode ): void =>
	{
		dispatch( setListMode( mode < ScreenMode.TABLET ) );
	}
}

/**
 * Module.
 */
export {
	RootList as default,
	RootListProps,
	RootListState,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/RootList.tsx